import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { KioskService } from '../services/KioskService';
import { IKioskTab } from '../interfaces/IKioskTab';

export const kioskTabsResolver: ResolveFn<IKioskTab[]> = () => {
  return inject(KioskService).getMandatorKioskTabs().pipe(
    map(res => res.data)
  );
};
